export default __webpack_public_path__ + "static/media/nextjs.42809537.svg";